import { render, staticRenderFns } from "./BookRequestSearchResultRow.vue?vue&type=template&id=23ed1af2&scoped=true"
import script from "./BookRequestSearchResultRow.vue?vue&type=script&lang=js"
export * from "./BookRequestSearchResultRow.vue?vue&type=script&lang=js"
import style0 from "./BookRequestSearchResultRow.vue?vue&type=style&index=0&id=23ed1af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed1af2",
  null
  
)

export default component.exports